import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(undefined, (error) => {
  const d = error?.response?.data;
  if (error?.response?.status === 402 && typeof d?.detail === "string" && d.detail.startsWith("BETA_")) {
    d.code = d.detail.split(":")[0];
    d.detail = d.detail.slice(d.code.length + 1).trim();
    window.dispatchEvent(new CustomEvent("qf:billing-refresh"));
  }
  return Promise.reject(error);
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export { api, API };
